import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import type { GatsbyImageProps, ImageDataLike } from 'gatsby-plugin-image';

type ImageProps = Omit<GatsbyImageProps, 'image'> & {
  image: ImageDataLike;
};

const Image = ({ image, ...rest }: ImageProps) => {
  const img = getImage(image);
  return img ? <GatsbyImage image={img} {...rest} /> : null;
};

export default Image;
